export default "__VITE_ASSET__CZkMQhUe__"